/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_RpgInputs */

const id_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPG`)
};

const ms_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPG`)
};

const da_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPG`)
};

const de_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPG`)
};

const en_us2_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPG`)
};

const es_es2_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPG`)
};

const es_mx2_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPG`)
};

const fil_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPG`)
};

const fr_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPG`)
};

const it_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPG`)
};

const hu_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPG`)
};

const nl_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPG`)
};

const no_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPG`)
};

const pl_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPG`)
};

const pt_br2_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPG`)
};

const pt_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPG`)
};

const ro_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPG`)
};

const fi_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPG`)
};

const sv_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPG`)
};

const vi_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPG`)
};

const tr_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPG`)
};

const cs_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPG`)
};

const bg_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPG`)
};

const ru_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPG`)
};

const uk_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPG`)
};

const ar_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPG`)
};

const hi_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPG`)
};

const th_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPG`)
};

const ja_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPG`)
};

const zh_cn2_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`角色扮演`)
};

const zh_hant1_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`角色扮演`)
};

const ko_nav_rpg = /** @type {(inputs: Nav_RpgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPG`)
};

/**
* | output |
* | --- |
* | "RPG" |
*
* @param {Nav_RpgInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_rpg = /** @type {((inputs?: Nav_RpgInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_RpgInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_rpg(inputs)
	if (locale === "ms") return ms_nav_rpg(inputs)
	if (locale === "da") return da_nav_rpg(inputs)
	if (locale === "de") return de_nav_rpg(inputs)
	if (locale === "en-US") return en_us2_nav_rpg(inputs)
	if (locale === "es-ES") return es_es2_nav_rpg(inputs)
	if (locale === "es-MX") return es_mx2_nav_rpg(inputs)
	if (locale === "fil") return fil_nav_rpg(inputs)
	if (locale === "fr") return fr_nav_rpg(inputs)
	if (locale === "it") return it_nav_rpg(inputs)
	if (locale === "hu") return hu_nav_rpg(inputs)
	if (locale === "nl") return nl_nav_rpg(inputs)
	if (locale === "no") return no_nav_rpg(inputs)
	if (locale === "pl") return pl_nav_rpg(inputs)
	if (locale === "pt-BR") return pt_br2_nav_rpg(inputs)
	if (locale === "pt") return pt_nav_rpg(inputs)
	if (locale === "ro") return ro_nav_rpg(inputs)
	if (locale === "fi") return fi_nav_rpg(inputs)
	if (locale === "sv") return sv_nav_rpg(inputs)
	if (locale === "vi") return vi_nav_rpg(inputs)
	if (locale === "tr") return tr_nav_rpg(inputs)
	if (locale === "cs") return cs_nav_rpg(inputs)
	if (locale === "bg") return bg_nav_rpg(inputs)
	if (locale === "ru") return ru_nav_rpg(inputs)
	if (locale === "uk") return uk_nav_rpg(inputs)
	if (locale === "ar") return ar_nav_rpg(inputs)
	if (locale === "hi") return hi_nav_rpg(inputs)
	if (locale === "th") return th_nav_rpg(inputs)
	if (locale === "ja") return ja_nav_rpg(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_rpg(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_rpg(inputs)
	return ko_nav_rpg(inputs)
});
export { nav_rpg as "nav.rpg" }